import { graphql } from 'gql';

export const bimWorkOrderVersionPricesGql = graphql(`
    query bimWorkOrderVersionPrices(
        $workOrderVersionId: Long!
        $workOrderVersionRootObjectId: Long!
        $chapter: BimChapterEnum!
        $includeRows: Boolean!
        $priceLevel: BimPriceLevelEnum
        $take: Int
        $skip: Int
        $where: BimWorkOrderVersionPriceDataFilterInput
    ) {
        bimWorkOrderVersionPrices(
            workOrderVersionId: $workOrderVersionId
            workOrderVersionRootObjectId: $workOrderVersionRootObjectId
            chapter: $chapter
            includeRows: $includeRows
            priceLevel: $priceLevel
            skip: $skip
            take: $take
            where: $where
        ) {
            totalCount
            items {
                id
                chapter
                object {
                    id
                    name
                }
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                workOrderVersionId
                workOrderVersionObjectId
                isLimitPrice
                hasRevisions
                hasActKC2
                hasUpdates
                isRevisionPrice
                isUpdatedPrice
                isActKC2Price
                completedTotalDeviation
            }
        }
    }
`);

export const bimWorkOrderPriceGql = graphql(`
    query bimWorkOrderPrices(
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $chapter: BimChapterEnum!
        $includeRows: Boolean!
        $priceLevel: BimPriceLevelEnum!
        $take: Int
        $skip: Int
        $where: BimWorkOrderPriceDataFilterInput
    ) {
        bimWorkOrderPrices(
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            chapter: $chapter
            includeRows: $includeRows
            priceLevel: $priceLevel
            skip: $skip
            take: $take
            where: $where
        ) {
            totalCount
            items {
                id
                chapter
                object {
                    id
                    contractObjectId
                    name
                }
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                workOrderId
                workOrderObjectId
                isLimitPrice
                hasRevisions
                hasActKC2
                hasUpdates
                isRevisionPrice
                isUpdatedPrice
                isActKC2Price
                canRemovedToActKC2
                completedTotalDeviation
            }
        }
    }
`);

export const bimWorkOrderPriceRows = graphql(`
    query bimWorkOrderPriceRows($workOrderPriceId: Long!, $priceLevel: BimPriceLevelEnum) {
        bimWorkOrderPriceRows(workOrderPriceId: $workOrderPriceId, priceLevel: $priceLevel) {
            items {
                id
                workOrderId
                workOrderPriceId
                type
                sectionId
                sectionNane
                value {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    mz
                    total
                    oz
                    tzr
                }
            }
        }
    }
`);

export const bimWorkOrderDeletePricesGql = graphql(`
    mutation bimRemoveWorkOrderPrices($workOrderId: Long!, $workOrderPriceIds: [Long!]!) {
        bimRemoveWorkOrderPrices(workOrderId: $workOrderId, workOrderPriceIds: $workOrderPriceIds) {
            data {
                workOrderId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderPricesToActKC2Gql = graphql(`
    mutation bimRemoveWorkOrderPricesToActKC2($workOrderId: Long!, $workOrderPriceIds: [Long!]!) {
        bimRemoveWorkOrderPricesToActKC2(workOrderId: $workOrderId, workOrderPriceIds: $workOrderPriceIds) {
            data {
                itemIds
                workOrderId
                isWorkOrderChangeRequired
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderPriceRevisionsGql = graphql(`
    query bimWorkOrderPriceRevisions(
        $order: [BimWorkOrderPriceRevisionDataSortInput!]
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $priceLevel: BimPriceLevelEnum
        $skip: Int
        $take: Int
        $where: BimWorkOrderPriceRevisionDataFilterInput
        $workOrderPriceId: Long!
    ) {
        bimWorkOrderPriceRevisions(
            order: $order
            revisionType: $revisionType
            priceLevel: $priceLevel
            skip: $skip
            take: $take
            where: $where
            workOrderPriceId: $workOrderPriceId
        ) {
            items {
                id
                priceUpdateDate
                isRevisionPrice
                isUpdatedPrice
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                isRevisionPrice
                isUpdatedPrice
            }
            totalCount
        }
    }
`);

export const bimWorkOrderVersionPriceRevisionsGql = graphql(`
    query bimWorkOrderVersionPriceRevisions(
        $order: [BimWorkOrderVersionPriceRevisionDataSortInput!]
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $priceLevel: BimPriceLevelEnum
        $skip: Int
        $take: Int
        $where: BimWorkOrderVersionPriceRevisionDataFilterInput
        $workOrderVersionPriceId: Long!
    ) {
        bimWorkOrderVersionPriceRevisions(
            order: $order
            revisionType: $revisionType
            priceLevel: $priceLevel
            skip: $skip
            take: $take
            where: $where
            workOrderVersionPriceId: $workOrderVersionPriceId
        ) {
            items {
                id
                priceUpdateDate
                isRevisionPrice
                isUpdatedPrice
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                isRevisionPrice
                isUpdatedPrice
            }
            totalCount
        }
    }
`);

export const bimActsKC2Gql = graphql(`
    query bimActsKC2(
        $order: [BimActKC2DataSortInput!]
        $skip: Int
        $take: Int
        $where: BimActKC2DataFilterInput
        $workOrderPriceId: Long!
        $priceLevel: BimPriceLevelEnum
    ) {
        bimActsKC2(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderPriceId: $workOrderPriceId
            priceLevel: $priceLevel
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                calcMethod
                currentPriceTotal
                workOrderId
                year
                month
                number
                date
                startDate
                finishDate
                value {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                canRemoved
                useInflationValue
                isCorrection
                isInactive
                correctionNumber
                fullNumber
                hasDeflation
            }
            totalCount
        }
    }
`);

export const bimRemoveActsKC2Gql = graphql(`
    mutation bimRemoveActsKC2($actKC2Ids: [Long!]!, $workOrderPriceId: Long!) {
        bimRemoveActsKC2(actKC2Ids: $actKC2Ids, workOrderPriceId: $workOrderPriceId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderPriceCodeFilterGql = graphql(`
    query bimWorkOrderPriceCodeFilter(
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceCodeFilter(
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderPriceNameFilterGql = graphql(`
    query bimWorkOrderPriceNameFilter(
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceNameFilter(
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderPriceObjectNameFilterGql = graphql(`
    query bimWorkOrderPriceObjectNameFilter(
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceObjectNameFilter(
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            chapter: $chapter
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderPriceRowCodeFilterGql = graphql(`
    query bimWorkOrderPriceRowCodeFilter(
        $workOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceRowCodeFilter(
            workOrderPriceId: $workOrderPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderPriceRowNameFilterGql = graphql(`
    query bimWorkOrderPriceRowNameFilter(
        $workOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceRowNameFilter(
            workOrderPriceId: $workOrderPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
